import { reducer as app } from '@containers/Home/slice';
import { combineReducers } from 'redux';

export const reducers = combineReducers({
  app,
});
